import Platform from '@/plugin-platforms'
import { webUrl } from '@/lib/route'

export const state = () => ({
  selected: {
    item: null,
    fn: null,
    svg: false
  }
})

export const getters = {
  itemUuid (state) {
    return state.selected.item && state.selected.item.uuid
  },
  canInsert (state) {
    return state.selected.item && state.selected.item.uuid !== null
  },
  insertAsSvg (state, getters, rootState, rootGetters) {
    return state.selected.svg && rootState.settings.iconFormat === 'svg'
  }
}

export const mutations = {
  select (state, { fn, item, svg }) {
    state.selected.item = item
    state.selected.fn = fn
    state.selected.svg = svg
  },
  clear (state) {
    state.selected.item = null
    state.selected.fn = null
    state.selected.svg = false
  }
}

export const actions = {
  onInsert ({ state, getters }) {
    if (getters.canInsert) {
      state.selected.fn()
    } else {
      console.log('Please selected an item to insert.')
    }
  },
  onClose () {
    Platform.close()
  },
  onOpenInWeb ({ state }) {
    const item = state.selected.item
    let url = webUrl(item.asset, { slug: item.slug })
    Platform.openURL(url)
  }
}
